<template>
  <div id="app-main">
    <el-row>
      <el-col>
        <div class="page-title-box flex-between">
          <h4 class="page-title">实时在线课程</h4>
          <div class="page-title date-range">更新频率：1小时更新1次</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-card>
          <el-row class="mb-3 flex-between">
            <el-col>
              <div class="flex-between">
                <div>
                  <el-button
                    type="out-line"
                    class="return-btn"
                    icon="el-icon-arrow-left"
                    size="small"
                    @click="goBack"
                  ></el-button>
                </div>
                <div>
                  <el-button
                    type="primary"
                    :disabled="downDisabled"
                    @click="exportTable"
                    >下载</el-button
                  >
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="mb-3">
            <el-col>
              <el-table id="invalid-course-table" :data="tableData" stripe>
                <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="统计时间段"
                ></el-table-column>
                <el-table-column prop="number" label="课程数"></el-table-column>
                <el-table-column prop="fullname" label="操作">
                  <template slot-scope="scope">
                    <span class="operative" @click="checkCourseList(scope.row)">
                      查看课程列表
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <a href=""></a>
          <div class="row flex-end">
            <Pagination
              :totalSize="totalSize"
              :currentPage="currentPage"
              @setPageSizesVal="getPageSizesVal"
              @setCurPageVal="getCurPageVal"
            ></Pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import { getCascader } from "@/utils/format.js";
import { domainName } from "@/config/setting.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      timerange: "",
      // 页码数据
      totalSize: null,
      currentPage: 1,
      pageSizesVal: 10,
      downDisabled: true,
      loaded: false,
    };
  },
  mounted() {
    this.getOnlineDataApi();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取实时在线数据/下载表格
    async getOnlineDataApi(type = "") {
      await this.$store
        .dispatch("platform/getOnlineData", {
          type: "course",
          print: type === "download" ? 1 : 0,
          page: this.currentPage,
          pagesize: this.pageSizesVal,
          responseType: type === "download" ? "blob" : "",
        })
        .then((res) => {
          if (type === "download") {
            const link = document.createElement("a"); // 创建a标签
            let blob = new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            }); //文件流处理
            link.style.display = "none"; //去除a标签的样式
            // 设置连接
            link.href = URL.createObjectURL(blob);
            link.download = "实时在线课程";
            document.body.appendChild(link);
            //模拟点击事件
            link.click();
            //移除创建的a标签
            window.URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          } else if (res.code === 1) {
            console.log("res:", res);
            this.timerange = res.data.time;
            this.tableData = res.data.data.list;
            this.totalSize = res.data.data.paging.records;
            console.log("tableData", this.tableData);
            if (!this.loaded) {
              this.loaded = !this.loaded;
              if (this.tableData.length > 0) {
                this.downDisabled = false;
              }
            }
          }
        })
        .catch((err) => {
          console.log("err:", err);
          this.$notify.error({ title: err.message });
        });
    },
    // 查看课程列表
    checkCourseList(row) {
      console.log("row", row);
      this.$router.push({
        path: "/platform/courseList",
        query: {
          id: row.id,
          date: row.date,
        },
      });
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal;
      this.getOnlineDataApi();
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal;
      this.getOnlineDataApi();
    },
    exportTable() {
      this.$notify.success({ title: "开始下载" });
      this.getOnlineDataApi("download");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .schoolyear.el-select .el-input__inner {
    width: 180px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .institute.el-select .el-input__inner {
    width: 240px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .schoolyear.el-select .el-input .el-select__caret,
  .institute.el-select .el-input .el-select__caret {
    color: #3294f6;
    font-weight: bold;
  }
  .schoolyear.el-select,
  .institute.el-select {
    .el-input__inner::placeholder {
      color: #3294f6;
    }
  }
  .el-input {
    .el-input__inner {
      border-radius: 3px;
    }
  }
  .select-auto-fit-style {
    .el-input__prefix {
      // prefix与input的样式保持一致，这样才能与原来重合对齐
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      padding-right: 30px;
      left: 0;
      position: relative;
      visibility: hidden;
      text-align: center;
    }
    .el-input__inner {
      position: absolute;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
.page-title-box {
  h4.page-title {
    font-weight: 600;
    .sub-title {
      font-size: 14px;
      color: #98a6ad;
      line-height: 21px;
      font-weight: 500;
    }
  }
}
.table-title {
  font-size: 18px;
  font-weight: 600;
  .sub-title {
    font-size: 14px;
    color: #98a6ad;
    line-height: 21px;
    font-weight: 500;
  }
}
.date-range {
  color: rgba(108, 117, 125, 1);
  font-size: 14px;
}
.range-condition {
  margin-right: 24px;
}
.selectbox {
  margin-right: 11px;
}
.empty-course {
  height: 320px;
  background-color: white;
  background-repeat: no-repeat;
  background-clip: content-box;
  .empty-course-tips {
    margin-top: 24px;
    color: rgba(152, 166, 173, 1);
    font-size: 18px;
  }
}
.course-card {
  cursor: pointer;
  .cover-img {
    width: 100%;
    height: 0;
    padding-bottom: 55.4%;
    overflow: hidden;
    background-image: url("~@/assets/images/course/course-cover.png");
    background-size: cover;
    background-repeat: no-repeat;
  }
  .course-name {
    margin-top: 24px;
    color: rgba(52, 58, 64, 1);
    font-size: 18px;
    line-height: 18px;
    font-weight: bold;
  }
  .teacher-name {
    margin-top: 16px;
    color: rgba(152, 166, 173, 1);
    font-size: 14px;
    line-height: 14px;
  }
}
.level2-option {
  padding-left: 30px;
}
.operative {
  color: #409eff;
  margin-right: 1rem;
  cursor: pointer;
}
</style>
